<template lang="pug">
b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
  .row.w-100
    .form-group.col-12.mb-1.ml-1
      div {{ $t('message.themeMenuMessage1') }}
      div(style="margin-top:-9px") {{ $t('message.themeMenuMessage2') }}
  .row.siteinfo-menu
    template(v-if="showMenu")
      .col-lg-6.col-12
        menupanel(ref="menupanel" :siteId="siteId" :menuList="menuList" @clickedMenu="getInfo" @callSync="callSync()")
      .col-lg-6.col-12(v-if="gameMenuList.length > 0")
        gamemenupanel(ref="gamemenupanel" :siteId="siteId" :gameMenuList="gameMenuList" @clickedMenu="getInfo" @callSync="callSync()")
      .col-lg-6.col-12(v-if="specialMenuList.length > 0")
        specialmenupanel(ref="specialmenupanel" :siteId="siteId" :specialMenuList="specialMenuList" @clickedMenu="getInfo" @callSync="callSync()")
      .col-lg-6.col-12(v-if="settingMenuList.length > 0")
        settingmenupanel(ref="settingmenupanel" :siteId="siteId" :settingMenuList="settingMenuList" @clickedMenu="getInfo" @callSync="callSync()")

  //- .row
  //-   .col
  //-     b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import menupanel from "@/components/siteeditor/menu/menuPanel.vue";
import gamemenupanel from "@/components/siteeditor/menu/gameMenuPanel.vue";
import specialmenupanel from "@/components/siteeditor/menu/specialMenuPanel.vue";
import settingmenupanel from "@/components/siteeditor/menu/settingMenuPanel.vue";
import SubmitButton from "@/library/SubmitButton";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    menupanel,
    gamemenupanel,
    specialmenupanel,
    settingmenupanel
  },
  props: {
    siteId: {
      type: Number
    },
    siteInfo: {
      type: Array
    },
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      menuData: [],
      gameMenuData: [],
      specialMenuData: [],
      settingMenuData: [],
      showMenu: false,

      menuList: [],
      gameMenuList: [],
      specialMenuList: [],
      settingMenuList: [],
    };
  },
  mounted() {
    this.assignAllMenu();
  },
  methods: {
    getInfo() {
      this.$emit("clicked");
    },
    assignAllMenu() {
      var menuList = this.siteInfo;
      var menu = [];
      var game = [];
      var special = [];
      var settingDropDown = [];

      for(var i = 0; i < menuList.length; i++) {
        var info = menuList[i]
        if(info.theme_content_group == 'menu') {
          menu.push(info)
        } else if(info.theme_content_group == 'game_menu') {
          game.push(info)
        } else if(info.theme_content_group == 'special') {
          special.push(info)
        } else if(info.theme_content_group == 'dropdown') {
          settingDropDown.push(info)
        }
      }

      this.menuList = menu;
      this.gameMenuList = game;
      this.specialMenuList = special;
      this.settingMenuList = settingDropDown;
      this.showMenu = true
    },
    reset() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    callSync() {
      this.$emit("callSync");
    }
  }
};
</script>